diy.angular.registerFactory('diyfmconfig', [function() {
    var 
        defaultConfig = {
            appName: 'filemanager',
            mode: 'management',
            maxSelection: 1,
            alreadyExisting: 0,
            shouldShowFileNames: false,
            sources: {},
            callback: function(){},
            defaultUploadTarget: 'storage',
            imageAspectRatio: 4/3,
            thumbWidth: 120,
            previewWidth: 600
        }
        config = angular.copy(defaultConfig)
    ;

    var setConfig = function(newConfig) {
        config = angular.extend(defaultConfig, newConfig);
    };

    var getConfig = function() {
        if (!config) {
            throw new Error('Config unset');
        }
        return config;
    };
    
    var getAppName = function() {
        return config.appName;
    };

    var isInManagementMode = function() {
        return config.mode === 'management';
    };

    var getMaxSelection = function() {
        return config.maxSelection;
    };

    var getAlreadyExisting = function() {
        return config.alreadyExisting;
    };

    var getSources = function() {
        var sources = [];
        for(var s in config.sources) {
            if (config.sources.hasOwnProperty(s) && config.sources[s] !== false) {
                sources.push(s);
            }
        }
        return sources;
    };
    
    var getSourceCallback = function(sourceName) {
        if (config.sources[sourceName]) {
            if(typeof config.sources[sourceName] === 'function') {
                return config.sources[sourceName];
            } else if (typeof config.sources[sourceName].callback === 'function') {
                return config.sources[sourceName].callback;
            }
        }
    };
    
    var getSourceBatchSize = function(sourceName) {
        if (config.sources[sourceName]
            && typeof config.sources[sourceName].batchSize !== 'undefined'
        ) {
            return config.sources[sourceName].batchSize;
        }
    };
    
    var getSourceSetting = function(sourceName, settingName) {
        if (config.sources[sourceName]
            && typeof config.sources[sourceName][settingName] !== 'undefined'
        ) {
            return config.sources[sourceName][settingName];
        }
    };
    
    var getCallback = function() {
        if(typeof config.callback === 'function') {
            return config.callback;
        }
    };

    var shouldShowFileNames = function() {
        return config.shouldShowFileNames;
    };
    
    var getDefaultUploadTarget = function() {
        return config.defaultUploadTarget;
    };
    
    var getPreviewSize = function() {
        return {
            width: config.previewWidth,
            height: config.previewWidth / config.imageAspectRatio
        }
    };
    
    var getThumbSize = function() {
        return {
            width: config.thumbWidth,
            height: config.thumbWidth / config.imageAspectRatio
        }
    };

    return {
        setConfig: setConfig,
        getConfig: getConfig,
        
        getAppName: getAppName,
        getSources: getSources,
        getSourceCallback: getSourceCallback,
        getSourceBatchSize: getSourceBatchSize,
        getSourceSetting: getSourceSetting,
        getCallback: getCallback,

        isInManagementMode: isInManagementMode,
        getMaxSelection: getMaxSelection,
        getAlreadyExisting: getAlreadyExisting,
        shouldShowFileNames: shouldShowFileNames,
        getDefaultUploadTarget: getDefaultUploadTarget,
        getThumbSize: getThumbSize,
        getPreviewSize: getPreviewSize
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/services/diyfmconfig.js
 ** module id = 939
 ** module chunks = 0
 **/